/*
 * @Author: zhangjun
 * @Date: 2023-06-25 16:37:47
 * @LastEditors: zhangjun
 * @LastEditTime: 2023-06-29 16:27:30
 * @Description:
 * @FilePath: /src/serverice/request-tdp.js
 */
import axios from "axios";
const str = "hw-tdp-o.api.leiniao.com";
let serviceBaseUrl = "";
const getUrl = () => str;
process.env.NODE_ENV === "production"
  ? ['hw-test.rayneo.cn'].includes(window.location.hostname) ? (serviceBaseUrl = "https://tdp-t.api.leiniao.com") : (serviceBaseUrl = `${location.protocol}//${getUrl()}`)
  : (serviceBaseUrl = "/tdpApi");
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});
export default service;
